import { createClient } from '@supabase/supabase-js';

// Las claves anon de Supabase son seguras para exponer en el cliente
// La seguridad real viene de las Row Level Security (RLS) policies en Supabase
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://jujbtvlrrbzdufiuedqa.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_heGjqSN0pE07EUBEcXBZlw_lCX2cEmG';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
